import "~/index.css";
import "~/util/FocusManager";

import * as React from "react";
import * as ReactDOM from "react-dom";

import Root from "~/containers/Root";
import client from "~/graphql/client";
import { theme } from "~/styled/theme";

import "~/util/sentry";

ReactDOM.render(<Root client={client} theme={theme} />, document.getElementById(
  "root"
) as HTMLElement);



// WEBPACK FOOTER //
// ./src/index.tsx